<template>
  <div class="card">
    <div class="card-body">
      <form action="#" class="floating-labels" v-on:submit.prevent="onSubmit">
<!--        <h4>Звернення читача</h4>-->

        <b-form-group>
          <b-form-checkbox-group
              id="checkbox-group-1"
              v-model="selected"
              value-field="id"
              text-field="name"
              :options="items"
              name="actions"
              stacked
          ></b-form-checkbox-group>
        </b-form-group>

        <div class="form-group">
          <button type="submit" class="btn btn-success btn-lg" style="font-size: 15px;">
            <i class="mdi mdi-check-circle"></i> Зберегти
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "EnableActionsForm",
  data: function () {
    return {
      items: [],
      selected: []
    }
  },
  mounted: function () {
    axios.get('/library/config?ajax=true')
        .then(response => response.data)
        .then(response => {
          this.items = response.actions.all;
          this.selected = response.actions.selected;
        });
  },
  methods: {
    onSubmit: function () {
      axios.post('/library/actions', { actions: this.selected })
        .then(response => response.data)
        .then(response => Swal('Збережено!'))
        .catch(err => {
          Swal('Дані не збережено!');
          console.log(err.response.data);
        });
    }
  }
}
</script>

<style scoped>

</style>
